import React, { useContext, useEffect, useState, FunctionComponent, useRef } from 'react';
import styled from 'styled-components';
import {
	PupillaryDistanceBaseProviderReceivedMessage,
	PupillaryDistanceBaseProviderResponseMessage,
	PupillaryDistanceProviderProps,
	TryOnBaseProviderReceivedMessage,
	TryOnBaseProviderResponseMessage,
	TryOnMode,
	TryOnProviderExchangeData,
	TryOnProviderProps,
	ValueOf,
	parseJSON
} from '../tryOnModels';
import { useZakekeTryOn } from '../../../hooks/tryonContext';
import { TryOnFrame } from '../tryOnFrame';
import { useInternalState } from '../../../state/provider';
import { TryOnType } from 'src/models';

// #region interfaces
const BanubaTryOnBaseReceivedMessage = {
	WaitingAuthentication: 'WAITING_AUTH',
	TryOnLoaded: 'MODEL_LOADED',
	ScreenShotTaken: 'SCREENSHOT_TAKEN',
	WebcamStopped: 'WEBCAM_STOPPED'
} as const;
export const BanubaTryOnReceivedMessage = { ...TryOnBaseProviderReceivedMessage, ...BanubaTryOnBaseReceivedMessage } as const;
export type BanubaTryOnReceivedMessageType = ValueOf<typeof BanubaTryOnReceivedMessage>;

const BanubaTryOnBaseResponseMessage = {
	StartAuthenticationTryOn: 'AUTH',
	LoadTryOn: 'LOAD_MODEL',
	LoadHands: 'LOAD_HANDS',
	TakeScreenshot: 'TAKE_SCREENSHOT',
	StopWebcam: 'STOP_WEBCAM'
} as const;

const BanubaHandTypes = [
	//QUI TIPI DI PRODOTTI CHE RICHIEDONO LE MANI
] as TryOnType[];

export const BanubaTryOnResponseMessage = { ...TryOnBaseProviderResponseMessage, ...BanubaTryOnBaseResponseMessage } as const;
export type BanubaTryOnResponseMessageType = ValueOf<typeof BanubaTryOnResponseMessage>;
//#endregion

const BanubaTryOnComponentContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: white;
	display: flex;
	& .tryon-banuba-frame {
		width: 77%;
		height: 100%;
		border: none;
		outline: none;
		margin: auto;
	}
`;

// #region virtual try on

export const BanubaTryOn: FunctionComponent<TryOnProviderProps> = (props) => {
	const internalState = useInternalState();
	const stateRef = useRef(internalState);
	stateRef.current = internalState;
	const store = stateRef.current.state.environment;
	const [tryOnState, setTryOnState] = useState({} as TryOnProviderExchangeData);
	const { tryon, setTryon } = useZakekeTryOn();
	const [frameWindow, setFrameWindow] = useState(null as Window | null);
	const frameWindowRef = useRef<Window | null>();
	frameWindowRef.current = frameWindow;

	useEffect(() => {
		setTryon({
			...tryon,
			closeFrame: () => tryon?.setVisible?.(false),
			takeScreenshot: () => sendMessage(frameWindowRef.current!, BanubaTryOnResponseMessage.TakeScreenshot, null),
			switchToPDTool: () => {
				console.log('switchToPDTool');
			},
			switchToTryOn: () => {
				console.log('switchToTryOn');
			},
			startPupillaryDistance: (time) => {
				console.log('startPupillaryDistance');
			}
		});
	}, []);

	useEffect(() => {
		switch (tryOnState.type) {
			// TRYON MESSAGES
			case BanubaTryOnReceivedMessage.Start:
				break;
			case BanubaTryOnReceivedMessage.WaitingAuthentication:
				sendMessage(frameWindow!, BanubaTryOnResponseMessage.StartAuthenticationTryOn, {
					token: Zakeke.config.banubaSettings.token
				});
				break;
			case BanubaTryOnReceivedMessage.AuthSuccessful:
				if (BanubaHandTypes.includes(props.product.typeID)) {
					sendMessage(frameWindow!, BanubaTryOnResponseMessage.LoadHands, null);
					setTimeout(() => {
						sendMessage(frameWindow!, BanubaTryOnResponseMessage.LoadTryOn, {
							glb: props.obj,
							settings: props.fineTuningSettings
						});
					}, 1500);
					return;
				}
				sendMessage(frameWindow!, BanubaTryOnResponseMessage.LoadTryOn, {
					glb: props.obj,
					settings: props.fineTuningSettings
				});
				break;
			case BanubaTryOnReceivedMessage.TryOnLoaded:
				props.onLoaded?.();
				break;
			case BanubaTryOnReceivedMessage.WebcamError:
				props.onWebcamError();
				break;
			case BanubaTryOnReceivedMessage.WebcamStopped:
				props.onClose?.();
				break;
		}
	}, [tryOnState]);

	const sendMessage = (window: Window, message: BanubaTryOnResponseMessageType, value: any) => {
		window.postMessage({ type: message, ...value }, '*');
	};

	const handleMessage = (e: MessageEvent) => {
		setTryOnState(e.data as TryOnProviderExchangeData);
	};

	return (
		<BanubaTryOnComponentContainer className={`Banuba-tryon ${props.className ? props.className : ''}`}>
			<TryOnFrame
				providerTitle='banuba'
				providerUrl={Zakeke.config.banubaSettings.url}
				onReady={(w) => {
					setFrameWindow(w);
					props.onReady?.();
				}}
				outMessageHandler={handleMessage.bind(this)}
			/>
		</BanubaTryOnComponentContainer>
	);
};

// #endregion
